import React from 'react';
import { observer } from 'mobx-react';
import {
  VariantModel,
  VariantSpecsCategoryModel,
} from '../../models/VariantModel';
import BreakpointStore from '../../stores/BreakpointStore';
import SpecsFeaturesAccordion from './SpecsFeaturesAccordion';

interface SpecsFeaturesTableState {
  breakpoint: BreakpointStore;
}

interface SpecsFeaturesTableProps {
  content: VariantModel[];
  currentIndex: number;
  specsAndFeaturesDisclaimer: string;
}

@observer
class SpecsFeaturesTable extends React.Component<
  SpecsFeaturesTableProps,
  SpecsFeaturesTableState
> {
  get currentVariants(): VariantModel[] {
    const { content, currentIndex } = this.props;
    const variants = [];

    if (!this.state.breakpoint.isMobile) {
      //Curr
      variants.push(content[currentIndex]);

      //Next
      if (typeof content[currentIndex + 1] !== 'undefined')
        variants.push(content[currentIndex + 1]);

      //Next Next
      if (typeof content[currentIndex + 2] !== 'undefined')
        variants.push(content[currentIndex + 2]);
    } else {
      variants.push(content[currentIndex]);
    }

    return variants;
  }

  get specGroups(): string[] {
    const { content, currentIndex } = this.props;

    const groups = content[currentIndex].specs.map(
      (specGroup: VariantSpecsCategoryModel) => {
        return specGroup.label;
      }
    );

    return groups;
  }

  get specFeaturesGroups(): string[] {
    const { content, currentIndex } = this.props;

    const groups = content[currentIndex].specFeatures.map(
      (specGroup: VariantSpecsCategoryModel) => {
        return specGroup.label;
      }
    );

    return groups;
  }

  constructor(props: SpecsFeaturesTableProps) {
    super(props);
    this.state = {
      breakpoint: new BreakpointStore(),
    };

    this.getRowData = this.getRowData.bind(this);
    this.getGroupsForCategory = this.getGroupsForCategory.bind(this);
    this.renderGroup = this.renderGroup.bind(this);
  }

  getGroupsForCategory(category: string) {
    const groups = this.currentVariants.filter((variant, index) => {
      if (!variant[category].length) {
        console.log('--------');
        console.log(
          `Following variant(${index}) has no items for: ${category}`
        );
        console.log(variant);
        console.log('--------');
        return false;
      } else {
        return true;
      }
    });

    if (!groups.length) {
      console.log('No variant has items for: ' + category);
      return [];
    }

    return groups[0][category];
  }

  getRowData(category: string, groupIndex: number, rowIndex: number) {
    return this.currentVariants.map((variant, variantIndex) => {
      if (typeof variant[category][groupIndex] === 'undefined') {
        console.log(
          `Failing to get row data for variants[${variantIndex}]['${category}'][${groupIndex}]`
        );
        return {
          label: '?',
          variant: variant.name,
          items: [],
        };
      } else {
        return {
          variant: variant.name,
          items: variant[category][groupIndex].items[rowIndex],
        };
      }
    });
  }

  renderGroup(key: string) {
    return this.getGroupsForCategory(key).map((group, groupIndex) => {
      return (
        <SpecsFeaturesAccordion key={`specs__group${groupIndex}`}>
          <h4 className="specs__groupTitle">{group.label}</h4>
          <div className="specs__groupRows">
            {group.items.map((item, rowIndex) => {
              return (
                <div className="specs__row" key={`specs__row${rowIndex}`}>
                  {this.getRowData(key, groupIndex, rowIndex).map(
                    (res, colIndex) => {
                      const column = res.items;

                      if (typeof column === 'undefined') {
                        console.log('------');
                        console.log('Error showing column for:' + res.variant);
                        console.log(key);
                        console.log(group.label);
                        console.log(item);
                        console.log('------');
                      }

                      let label = column ? column.label : '.';
                      let padStart = false;
                      let disclaimer = column ? column.disclaimer : '';
                      let value = column ? column.value : '.';

                      if (label.charAt(0) === '+') {
                        label = label.substr(1);
                        padStart = true;
                      }

                      return (
                        <div
                          className={`specs__col ${
                            this.currentVariants.length <= 2
                              ? 'specs__col--half'
                              : ''
                          }`}
                          key={`specs__col${colIndex}`}
                        >
                          <div
                            className={`specs__colLabel ${
                              padStart ? 'specs__colLabel--padStart' : ''
                            }`}
                          >
                            {label}
                            {disclaimer ? (
                              <span className="tt">
                                *
                                <span
                                  className="tt__content"
                                  dangerouslySetInnerHTML={{
                                    __html: disclaimer,
                                  }}
                                />
                              </span>
                            ) : null}
                          </div>
                          <div className="specs__colValue">{value}</div>
                        </div>
                      );
                    }
                  )}
                </div>
              );
            })}
          </div>
        </SpecsFeaturesAccordion>
      );
    });
  }

  render() {
    return (
      <div className="specs">
        <div className="specs__category">
          <h3 className="specs__categoryTitle">
            Specs
            <span className="tt lighter-font-weight text-center">
              *
              <span className="tt__content">
                {this.props.specsAndFeaturesDisclaimer}
              </span>
            </span>
          </h3>
          {this.renderGroup('specs')}
        </div>

        <div className="specs__category">
          <h3 className="specs__categoryTitle">
            Features
            <span className="tt lighter-font-weight text-center">
              *
              <span className="tt__content">
                {this.props.specsAndFeaturesDisclaimer}
              </span>
            </span>
          </h3>
          {this.renderGroup('specFeatures')}
        </div>
      </div>
    );
  }
}

export default SpecsFeaturesTable;
